module.exports = __webpack_public_path__ + "img/menu-bg3.ab331fbc.png";